export const watermark = {
  "title": "Add Watermark",
  "editImageTitle": "Current Image",
  "titleUpdate": "Update Watermark",
  "addMessage": "This file already contains a Watermark. Would you like to update the existing Watermark with the one you are adding? </br>Note: If you choose to add another Watermark, it might overlap the existing one.",
  "addUpdateBtn": "Update Existing",
  "addNewBtn": "Add New",
  "emptyMessage": "The watermark content is empty, do you want to cancel this operation? Click \"OK\" to exit the Watermark dialog box, or click \"Cancel\" to continue with the current operations.",
  "removeMessage": "Do you want to delete the watermark from document?",
  "removeNoneMessage": "Foxit PDF Editor can't find any watermark in the document.",
  "preview": "Preview",
  "text": "Text: ",
  "opacity": "Opacity: ",
  "rotation": "Rotation: ",
  "source": "Source",
  "font": "Font: ",
  "size": "Size: ",
  "file": "File: ",
  "browse": "Browse...",
  "scale": "Absolute Scale: ",
  "pageNumber": "Page Number: ",
  "verticalDistance": "Vertical Distance: ",
  "horizontalDistance": "Horizontal Distance: ",
  "position": "Position",
  "from": "from",
  "appearance": "Appearance",
  "none": "None",
  "custom": "Custom",
  "scalRelativeToTargetPage": "Scale relative to target page",
  "location": "Location: ",
  "appearBehindPage": "Appear behind page",
  "appearOnTopOfPage": "Appear on top of page",
  "appearanceOptions": "Appearance Options",
  "appearanceOptionList": {
    "print": "Show when printing",
    "screen": "Show when displaying on screen",
    "keep": "Keep position and size of watermark text constant when printing on different page sizes"
  },
  "pageRange": "Page Range",
  "allPages": "All Pages",
  "pageForm": "Page From",
  "to": "To",
  "of": "of",
  "subset": "Subset: ",
  "subsets": {
    "all": "All pages in range",
    "even": "Even pages only",
    "odd": "Odd pages only"
  },
  "units": {
    "inch": "Inches",
    "percent": "Percent",
    "cm": "Centimeters",
    "mm": "Millimeters",
    "pica": "Picas",
    "point": "Points"
  },
  "vertPositions": {
    "top": "Top",
    "center": "Center",
    "bottom": "Bottom"
  },
  "horiPositions": {
    "left": "Left",
    "center": "Center",
    "right": "Right"
  },
  "advanceSetting": "Advanced Settings...",
  "hide": "Hide",
  "notPDF": "This file is not PDF",
  "overSize": "This file is over size(100M)",
  "passwordInput": {
    "title": "Password",
    "label": "Enter Owner Password",
    "empty": "Please input the owner password.",
    "errorMessage": "The owner password is not correct."
  },
  "notValid": "The page selection is not valid. Please select a valid page range.",
  "saveSettingTitle": "Save Settings",
  "saveSettingAs": "Save current setting as:",
  "saveSettingExist": "The setting name already exists. Do you want to replace the old setting?",
  "noFileFound": "The source file you specified could not be found. Please try to select again.",
  "deleteSetting": "Are you sure you want to delete the setting ${1}?",
  "saveSettingSelect": "Saved Settings:",
  "saveSettingBtn": "Save Settings",
  "saveImport": "Import watermark",
  "saveExport": "Export watermark",
  "saveDelete": "Delete watermark",
  "saveNoneDefine": "None specified"
}
